<template>
  <el-dialog
    title="上传"
    class="crm-upload"
    :visible.sync="visible"
    :before-close="handleCloseDialog"
  >
    <div class="step">
      <el-button disabled round v-if="isUpload">上传数据</el-button>
      <el-upload
        v-else-if="!isUpload"
        list-type="text"
        action="action"
        :show-file-list="false"
        :before-upload="handleBeforeUpload"
        :http-request="handleUploadFile"
      >
        <el-button type="primary" round>
          重新上传
        </el-button>
      </el-upload>
      <span class="step-line"></span>
      <el-button round type="primary" v-if="isMsg" @click="handleCloseDialog"
        >导入完成</el-button
      >
      <el-button disabled round v-else-if="!isMsg" slot="trigger"
        >导入完成</el-button
      >
    </div>
    <div>
      <el-button type="text" icon="el-icon-download">
        <a :href="download" download="下载模板.xlsx">下载模板</a>
      </el-button>
    </div>
    <el-upload
      ref="upload"
      v-show="isUpload"
      drag
      list-type="text"
      action="action"
      :file-list="fileList"
      :before-upload="handleBeforeUpload"
      :on-success="handleSuccess"
      :on-error="handleError"
      :http-request="handleUploadFile"
    >
      <div class="el-upload__text">
        <i class="el-icon-upload"></i>
        将文件拖到此处， 或<em>点击上传</em>
      </div>
      <div class="el-upload__tip" slot="tip">
        文件后缀名必须为： xls或xlsx（即Excel格式）
      </div>
    </el-upload>
    <div v-show="isMsg" class="msg">
      <el-row :class="msg[index].class">
        {{ msg[index].text }}
      </el-row>
      <el-row class="content">{{ message }}</el-row>
    </div>
  </el-dialog>
</template>

<script>
import { uploadFileVerify } from '@/scripts/reg';

export default {
  props: {
    visible: Boolean,
    handleClose: Function,
    upload: Function,
    download: String,
  },
  data() {
    return {
      active: 0,
      index: 1,
      message: '',
      fileList: [],
      uploading: false,
      isMsg: false,
      isUpload: true,
      msg: [
        {
          text: '恭喜您',
          class: 'success',
        },
        {
          text: '导入失败',
          class: 'fail',
        },
      ],
    };
  },
  methods: {
    async handleBeforeUpload(file) {
      const reg = /\.xl(s|sx)$/;
      if (!reg.test(file.name)) {
        this.$message({
          type: 'info',
          message: '文件后缀名必须为： xls或slxs!',
        });
        return false;
      }

      if (file.size === 0) {
        this.$message({
          type: 'info',
          message: '文件不能为空!',
        });
        return false;
      }

      try {
        return await uploadFileVerify(file.name);
      } catch (e) {
        this.$message(e);
        return Promise.reject();
      }
    },
    // 文件上传
    handleUploadFile(item) {
      this.uploading = true;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在上传中，请稍后...',
        duration: 0,
        showClose: false,
      });
      const params = new FormData();

      params.append('file', item.file);
      params.append('fileName', item.file.name);
      this.upload({
        params,
        config: { 'Content-Type': 'multipart/form-data', timeout: 300000 },
      })
        .then((res) => {
          item.onSuccess();
          if (res.data.data) {
            this.message = `导入成功，（共有${res.data.data}条数据）`;
          } else {
            this.message = '导入成功';
          }
          this.isMsg = true;
          this.isUpload = false;
          this.uploading = false;
          this.index = 0;
        })
        .catch((err) => {
          item.onError();
          this.message = err.message;
          this.isMsg = true;
          this.isUpload = false;
          this.uploading = false;
          this.index = 1;
        })
        .finally(() => {
          if (this.notify) this.notify.close();
        });
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handleError() {},
    handleCloseDialog() {
      if (!this.loading) {
        this.uploading = false;
        this.isMsg = false;
        this.isUpload = true;
        this.fileList = [];
        this.handleClose();
      }
    },
  },
};
</script>
<style>
.crm-upload .el-upload {
  width: 100%;
}
.crm-upload .el-upload-dragger {
  width: 100% !important;
}
.crm-upload .el-step__title.is-process {
  color: rgb(64, 158, 255);
}
.crm-upload .el-step__head.is-process {
  color: rgb(64, 158, 255);
}
.crm-upload .el-upload-dragger {
  line-height: 180px;
}
.msg {
  margin-top: 20px;
}
.step {
  display: flex;
  align-items: center;
}
.step-line {
  flex: 1;
  border-bottom: 1px solid #eee;
  height: 1px;
}
.success {
  font-size: xx-large;
  font-weight: 700;
  color: #00ff95;
  text-align: center;
}
.content {
  text-align: center;
  margin: 40px 0 20px;
}
.fail {
  font-size: large;
  font-weight: bold;
  color: red;
  text-align: center;
}
.el-button--primary.is-plain {
  border-radius: 20px;
}
</style>
